/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpindicativeorder_Success3Inputs */

const en_coinvestments_gpindicativeorder_success3 = /** @type {(inputs: Coinvestments_Gpindicativeorder_Success3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicative order updated successfully`)
};

/**
* | output |
* | --- |
* | "Indicative order updated successfully" |
*
* @param {Coinvestments_Gpindicativeorder_Success3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpindicativeorder_success3 = /** @type {((inputs?: Coinvestments_Gpindicativeorder_Success3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpindicativeorder_Success3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpindicativeorder_success3(inputs)
});
export { coinvestments_gpindicativeorder_success3 as "coInvestments_gpIndicativeOrder_success" }